<template>
  <el-dialog
    :title="$t('contractTypeSpecManage.add.title')"
    :visible.sync="visible"
    width="650px"
    custom-class="contract-type-spec-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="86px" label-position="right" class="contract-type-spec-form">
      <el-form-item
        :label="$t('contractTypeSpecManage.add.specName') + ':'"
        prop="specName"
      >
        <el-input
          v-model="formData.specName"
          :placeholder="$t('contractTypeSpecManage.add.specNamePlaceholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('contractTypeSpecManage.add.specHoldplace') + ':'"
        prop="specHoldplace"
      >
        <el-input
          v-model="formData.specHoldplace"
          :placeholder="$t('contractTypeSpecManage.add.specHoldplacePlaceholder')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('contractTypeSpecManage.add.required') + ':'"
        prop="required"
      >
        <el-select
          v-model="formData.required"
          :placeholder="$t('contractTypeSpecManage.add.requiredPlaceholder')"
          style="width:100%"
        >
          <el-option
            :label="$t('common.yes')"
            value="Y"
          />
          <el-option
            :label="$t('common.no')"
            value="N"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('contractTypeSpecManage.add.specShow') + ':'"
        prop="specShow"
      >
        <el-select
          v-model="formData.specShow"
          :placeholder="$t('contractTypeSpecManage.add.specShowPlaceholder')"
          style="width:100%"
        >
          <el-option
            :label="$t('common.yes')"
            value="Y"
          />
          <el-option
            :label="$t('common.no')"
            value="N"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('contractTypeSpecManage.add.specValueType') + ':'"
        prop="specValueType"
      >
        <el-select
          v-model="formData.specValueType"
          :placeholder="$t('contractTypeSpecManage.add.specValueTypePlaceholder')"
          style="width:100%"
        >
          <el-option
            :label="$t('contractTypeSpecManage.specValueType.string')"
            value="1001"
          />
          <el-option
            :label="$t('contractTypeSpecManage.specValueType.integer')"
            value="2002"
          />
          <el-option
            :label="$t('contractTypeSpecManage.specValueType.amount')"
            value="3003"
          />
          <el-option
            :label="$t('contractTypeSpecManage.specValueType.date')"
            value="4004"
          />
          <el-option
            :label="$t('contractTypeSpecManage.specValueType.time')"
            value="5005"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('contractTypeSpecManage.add.specType') + ':'"
        prop="specType"
      >
        <el-select
          v-model="formData.specType"
          :placeholder="$t('contractTypeSpecManage.add.specTypePlaceholder')"
          style="width:100%"
        >
          <el-option
            :label="$t('contractTypeSpecManage.specType.input')"
            value="2233"
          />
          <el-option
            :label="$t('contractTypeSpecManage.specType.select')"
            value="3344"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('contractTypeSpecManage.add.listShow') + ':'"
        prop="listShow"
      >
        <el-select
          v-model="formData.listShow"
          :placeholder="$t('contractTypeSpecManage.add.listShowPlaceholder')"
          style="width:100%"
        >
          <el-option
            :label="$t('common.yes')"
            value="Y"
          />
          <el-option
            :label="$t('common.no')"
            value="N"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="figma-btn-cancel" @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" class="figma-btn-confirm" @click="handleSubmit">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveContractTypeSpec } from '@/api/contract/contractTypeSpecManageApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'AddContractTypeSpec',
  data() {
    return {
      visible: false,
      formData: {
        specName: '',
        specHoldplace: '',
        required: '',
        specShow: '',
        specValueType: '',
        specType: '',
        listShow: '',
        contractTypeId: '',
        communityId: ''
      },
      rules: {
        specName: [
          { required: true, message: this.$t('contractTypeSpecManage.validate.specNameRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('contractTypeSpecManage.validate.specNameMaxLength'), trigger: 'blur' }
        ],
        specHoldplace: [
          { max: 200, message: this.$t('contractTypeSpecManage.validate.specHoldplaceMaxLength'), trigger: 'blur' }
        ],
        required: [
          { required: true, message: this.$t('contractTypeSpecManage.validate.requiredRequired'), trigger: 'change' }
        ],
        specShow: [
          { required: true, message: this.$t('contractTypeSpecManage.validate.specShowRequired'), trigger: 'change' }
        ],
        specValueType: [
          { required: true, message: this.$t('contractTypeSpecManage.validate.specValueTypeRequired'), trigger: 'change' }
        ],
        specType: [
          { required: true, message: this.$t('contractTypeSpecManage.validate.specTypeRequired'), trigger: 'change' }
        ],
        listShow: [
          { required: true, message: this.$t('contractTypeSpecManage.validate.listShowRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.formData.contractTypeId = data.contractTypeId
      this.formData.communityId = getCommunityId()
      this.visible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveContractTypeSpec(this.formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.visible = false
            this.$emit('success')
          } catch (error) {
            this.$message.error(error.message || this.$t('contractTypeSpecManage.add.error'))
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.contract-type-spec-dialog >>> .el-dialog { border-radius: 12px; overflow: hidden; }
.contract-type-spec-dialog >>> .el-dialog__header {
  height: 66px; box-sizing: border-box; padding: 22px 24px;
  background: #EBF2FA; border-bottom: 1px solid #DCE6F5;
}
.contract-type-spec-dialog >>> .el-dialog__title {
  font-size: 16px; color: #1D2129; font-weight: 600;
}
.contract-type-spec-dialog >>> .el-dialog__body {
  padding: 24px 24px 0;
}
.contract-type-spec-dialog >>> .el-dialog__footer {
  padding: 28px 24px 28px;
  display: flex; justify-content: flex-end; gap: 12px;
}
.contract-type-spec-form >>> .el-form-item { margin-bottom: 20px; }
.contract-type-spec-form >>> .el-form-item:last-child { margin-bottom: 0; }
.contract-type-spec-form >>> .el-form-item { display: flex; align-items: center; }
.contract-type-spec-form >>> .el-form-item__label {
  font-size: 14px; font-weight: 500; color: #1D2129;
  line-height: 38px; height: 38px; float: none;
  padding-right: 0;
}
.contract-type-spec-form >>> .el-form-item__content {
  flex: 1; margin-left: 0 !important; line-height: 38px;
}
.contract-type-spec-form >>> .el-form-item.is-required >>> .el-form-item__label::before {
  color: #FB2C36; margin-right: 4px;
}
.contract-type-spec-form >>> .el-input__inner,
.contract-type-spec-form >>> .el-select .el-input__inner {
  border-radius: 10px; border: 1px solid #DCE6F5;
  font-size: 14px; color: #1D2129; height: 38px;
}
.contract-type-spec-dialog >>> .el-dialog__footer .el-button {
  width: 98px;
  height: 38px;
  border-radius: 10px;
  padding: 0;
  font-size: 14px;
  font-family: 'PingFang SC', sans-serif;
  font-weight: 500;
}
.contract-type-spec-dialog >>> .el-dialog__footer .figma-btn-cancel {
  border: 1px solid #0E76FF;
  color: #0E76FF;
  background: white;
}
.contract-type-spec-dialog >>> .el-dialog__footer .figma-btn-cancel:hover {
  color: #0E76FF;
  background: white;
  border-color: #0E76FF;
}
.contract-type-spec-dialog >>> .el-dialog__footer .figma-btn-confirm {
  background: #0E76FF;
  border-color: #0E76FF;
  color: white;
}
.contract-type-spec-dialog >>> .el-dialog__footer .figma-btn-confirm:hover {
  background: #0E76FF;
  border-color: #0E76FF;
  color: white;
}
</style>